import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <button onClick={scrollToTop} className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/a7fa12b8ba3e9f29132c64cff29b528e/52f4eaf466cfed1c522eca41976a3427.png" 
              alt="Boostio" 
              className={`h-8 md:h-10 transition-all duration-300 ${isScrolled ? 'brightness-0' : 'brightness-0 invert'}`}
            />
          </button>

          <div className="hidden md:flex items-center gap-8 absolute left-1/2 transform -translate-x-1/2">
            <button onClick={() => scrollToSection('how-it-works')} className={`font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#1E3A8A]' : 'text-white hover:text-white/80'
            }`}>
              Miten toimii
            </button>
            <button onClick={() => scrollToSection('demo')} className={`font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#1E3A8A]' : 'text-white hover:text-white/80'
            }`}>
              Demo
            </button>
            <button onClick={() => scrollToSection('pricing')} className={`font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#1E3A8A]' : 'text-white hover:text-white/80'
            }`}>
              Hinnasto
            </button>
            <button onClick={() => scrollToSection('faq')} className={`font-medium transition-colors cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-[#1E3A8A]' : 'text-white hover:text-white/80'
            }`}>
              UKK
            </button>
          </div>

          <div className="hidden md:block">
            <button onClick={() => scrollToSection('trial-form')} className="bg-gradient-to-r from-[#1E3A8A] to-[#2563EB] text-white px-6 py-2.5 rounded-full hover:from-[#172554] hover:to-[#1E3A8A] transition-all cursor-pointer whitespace-nowrap font-semibold">
              Aloita ilmainen kokeilu
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className={`md:hidden mt-3 md:mt-4 py-3 md:py-4 rounded-2xl ${
            isScrolled ? 'bg-white' : 'bg-white/95 backdrop-blur-sm'
          } shadow-lg`}>
            <div className="flex flex-col space-y-1">
              <button 
                onClick={() => scrollToSection('how-it-works')} 
                className="text-gray-700 hover:bg-gray-50 px-4 md:px-6 py-2.5 md:py-3 text-left font-medium transition-colors cursor-pointer text-sm md:text-base"
              >
                Miten toimii
              </button>
              <button 
                onClick={() => scrollToSection('demo')} 
                className="text-gray-700 hover:bg-gray-50 px-4 md:px-6 py-2.5 md:py-3 text-left font-medium transition-colors cursor-pointer text-sm md:text-base"
              >
                Demo
              </button>
              <button 
                onClick={() => scrollToSection('pricing')} 
                className="text-gray-700 hover:bg-gray-50 px-4 md:px-6 py-2.5 md:py-3 text-left font-medium transition-colors cursor-pointer text-sm md:text-base"
              >
                Hinnasto
              </button>
              <button 
                onClick={() => scrollToSection('faq')} 
                className="text-gray-700 hover:bg-gray-50 px-4 md:px-6 py-2.5 md:py-3 text-left font-medium transition-colors cursor-pointer text-sm md:text-base"
              >
                UKK
              </button>
              <div className="px-4 md:px-6 pt-2">
                <button 
                  onClick={() => scrollToSection('trial-form')} 
                  className="w-full bg-gradient-to-r from-[#1E3A8A] to-[#2563EB] text-white px-6 py-2.5 md:py-3 rounded-full hover:from-[#172554] hover:to-[#1E3A8A] transition-all cursor-pointer whitespace-nowrap font-semibold text-sm md:text-base"
                >
                  Aloita ilmainen kokeilu
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}